
<div class="form-management-page">
  <div class="form-management-content">
    <NavigationBackButton/>

    <div class="form-management-card card">
      <div class="form-management-card-header d-flex flex-wrap justify-content-between align-items-start gap-3">
        <h2 class="form-management-card-title">
          <i class="bi bi-ui-checks me-2"></i>
          Form Management
        </h2>

        <div class="form-management-toolbar d-flex flex-wrap justify-content-lg-end gap-2 ms-lg-auto">
          <button
            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
            data-bs-toggle="modal"
            data-bs-target="#create_form"
            @click="open_create_modal"
          >
            Create New Form
          </button>
        </div>
      </div>

      <div class="card-body form-management-card-body">
        <div class="form-management-table-wrap">
          <table id="forms_table" class="table table-hover form-management-table">
            <thead class="custom-header">
              <tr>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Form Name</th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Description</th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Last Modified</th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Status</th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(form) in table_safe_form_list" :key="form.id">
                <td class="text-xxs text-start ps-3">{{ form.name }}</td>
                <td class="text-xxs text-start">{{ form.description }}</td>
                <td class="text-xxs text-start">{{ form.last_modified }}</td>
                <td class="text-xxs text-start">
                  <span class="status-badge" :class="form.status.toLowerCase()">{{ form.status }}</span>
                </td>
                <td class="text-xxs text-start">
                  <div class="form-management-actions d-flex gap-2 align-items-center">
                    <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                            data-bs-toggle="modal"
                            data-bs-target="#edit_form"
                            @click="open_edit_modal(form)">Edit</button>

                    <button @click="redirect_to_create_entity(form)"
                            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark">View</button>

                    <button class="d-none btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                            @click="selected_share_form_id(form.id)"
                            data-bs-toggle="modal"
                            data-bs-target="#share_trust_form">Share</button>

                    <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                            data-bs-toggle="modal"
                            data-bs-target="#assign_form"
                            @click="open_assign_modal(form)">Assign</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Create/Edit Form Modal -->
 <teleport to="body">
<div class="modal fade" id="edit_form" tabindex="-1" aria-labelledby="edit_form_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <h5 class="modal-title text-white text-xxs">Edit Form</h5>
        <button type="button" class="modal-btn-close btn-close"data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
              <label class="modal-form-label form-label text-xxs">Form Name:</label>
              <input type="text" class="modal-form-control form-control text-xxs" v-model="current_form.form_name" placeholder="Enter form name">
          </div>
          <div class="mb-3">
              <label class="modal-form-label form-label text-xxs">Form Description:</label>
              <textarea class="modal-form-control form-control text-xxs" v-model="current_form.form_description" ></textarea>
          </div>
          <div class="d-none mb-3">
            <label class="modal-form-label form-label text-xxs">Form Type:</label>
            <select class="modal-form-control form-control text-xxs"
                    v-model="current_form.form_type_id">
              <option disabled value="">Select Form Type</option>
              <option v-if="!form_types.length" disabled>(No form types found)</option>
              <option v-for="type in form_types" :key="type.id" :value="type.id">
                {{ type.form_type }}
              </option>
            </select>

            </div>
          </div>
          <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="update_form">
            Save
          </button>

        </div>
    </div>
    </div>
</div>
</teleport>

<teleport to="body">
<div class="modal fade" id="assign_form" tabindex="-1" aria-labelledby="assign_form_label" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">

        <!-- Header -->
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <h5 class="modal-title text-white text-xxs">Assign Form: {{ current_form.form_name }}</h5>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <!-- Body -->
        <div class="modal-body px-4 py-4">
          <div class="mb-4">
            <h6 class="mb-3 text-xxs fw-bold text-muted">Select Entity Types</h6>

            <div class="table-responsive">
              <table class="table table-sm align-middle mb-0">
                <thead class="custom-header text-uppercase text-xxs">
                  <tr>
                    <th class="ps-3">Type / Sub-Type Name</th>
                    <th>Description</th>
                    <th class="text-center">Assign</th>
                  </tr>
                </thead>

                <tbody>
                  <template v-for="(type, tIndex) in table_safe_trust_types" :key="type.id">
                    <!-- Entity Type Row -->
                    <tr class="bg-light border-top">
                      <td class="fw-bold text-xxs ps-3">{{ type.entity_type_name }}</td>
                      <td class="text-muted text-xxs">{{ type.entity_type_description }}</td>
                      <td class="text-center">
                        <div class="form-check form-switch d-flex justify-content-center">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            v-model="type.selected"
                            :id="'entity-' + tIndex"
                          >
                        </div>
                      </td>
                    </tr>

                    <!-- SubEntity Rows -->
                    <tr
                      v-for="(sub, sIndex) in type.sub_entities"
                      :key="sub.id"
                      class="subentity-row border-0"
                    >
                      <td class="ps-5 text-xxs">↳ {{ sub.sub_entity_name }}</td>
                      <td class="text-muted text-xxs">{{ sub.description || '—' }}</td>
                      <td class="text-center">
                        <div class="form-check form-switch d-flex justify-content-center">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            v-model="sub.selected"
                            :id="'sub-' + tIndex + '-' + sIndex"
                          >
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer justify-content-end px-4 pb-3">
          <button
            type="button"
            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
            @click="save_assignment"
          >
            Save Assignment
          </button>
        </div>

    </div>
  </div>
</div>
</teleport>

<!-- Create Form Modal -->
 <teleport to="body">
<div class="modal fade" id="create_form" tabindex="-1" aria-labelledby="assign_form_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <h5 class="modal-title text-white text-xxs">Create Form </h5>
            <button type="button" class="modal-btn-close btn-close"  data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
            <div class="mb-3">
              <label class="modal-form-label form-label text-xxs">How would you like to create this form?</label>
              <div class="d-flex flex-column gap-2">
                <label class="d-flex align-items-center gap-2 text-xxs">
                  <input
                    type="radio"
                    name="create_form_mode"
                    value="new"
                    v-model="create_mode"
                    @change="on_create_mode_change"
                  >
                  <span>Create a new form</span>
                </label>
                <label class="d-flex align-items-center gap-2 text-xxs">
                  <input
                    type="radio"
                    name="create_form_mode"
                    value="existing"
                    v-model="create_mode"
                    @change="on_create_mode_change"
                  >
                  <span>Pull an existing form</span>
                </label>
              </div>
            </div>
            <div class="mb-3" v-if="create_mode === 'existing'">
              <label class="modal-form-label form-label text-xxs">Existing Form:</label>
              <div class="position-relative">
                <select
                  class="modal-form-control form-control text-xxs pe-5"
                  v-model="selected_source_form_id"
                  :disabled="reusable_forms_loading"
                  @change="apply_selected_source_form"
                >
                  <option disabled value="">Select an existing form</option>
                  <option v-if="reusable_forms_loading" disabled>Loading forms...</option>
                  <option
                    v-for="form in reusable_forms"
                    :key="form.id"
                    :value="form.id"
                  >
                    {{ get_reusable_form_option_label(form) }}
                  </option>
                </select>
                <i class="bi bi-chevron-down position-absolute top-50 end-0 translate-middle-y me-3 text-secondary cursor-pointer dropdown-arrow"></i>
              </div>
            </div>
            <div class="mb-3">
                <label class="modal-form-label form-label text-xxs">Form Name:</label>
                <input type="text" class="modal-form-control form-control text-xxs" v-model="current_form.form_name" placeholder="Enter form name">
            </div>
            <div class="mb-3">
                <label class="modal-form-label form-label text-xxs">Form Description:</label>
                <textarea class="modal-form-control form-control text-xxs" v-model="current_form.form_description"></textarea>
            </div>
            <div class="mb-3">
              <label class="modal-form-label form-label text-xxs">Form Type:</label>
            <div class="position-relative">
              <select class="modal-form-control form-control text-xxs pe-5"
                      v-model="current_form.form_type_id">
                  <option disabled value="">Select Form Type</option>
                  <option v-for="type in form_types" :key="type.id" :value="type.id">
                      {{ type.form_type }}
                  </option>
              </select>
              <i class="bi bi-chevron-down position-absolute top-50 end-0 translate-middle-y me-3 text-secondary cursor-pointer dropdown-arrow"></i>
            </div>
            </div>

        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="create_forms">Save</button>
        </div>
        </div>
    </div>
</div>
</teleport>

<!-- Share Trust Form Modal -->
<teleport to="body">
<div class="modal fade" id="share_trust_form" tabindex="-1" aria-labelledby="shareTrustFormLabel" aria-hidden="true" ref="shareTrustFormModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <!-- Modal Header -->
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <h4 class="modal-title text-white text-xxs">Entity Configuration Summary</h4>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <!-- Info Alert -->
        <div class="alert alert-info mt-3 d-flex align-items-center text-xxs">
          <i class="fa-solid fa-info-circle me-2"></i>
          <span>The assigned user will receive an email with instructions to access and complete their entity setup.</span>
        </div>
        <!-- Assign Forms -->
        <div class="form-section mt-4 text-xxs">
          <label class="fw-bold mb-1" for="email">Assign forms by Email</label>
          <input type="email" v-model="email" class="modal-form-control form-control form-control-sm text-xxs p-2 rounded" placeholder="Enter email address" />

          <label class="fw-bold mt-3 mb-1" for="entity_type_select">Select Entity Type</label>
          <select v-model="selected_entity_type_id" class="form-select text-xxs">
            <option v-for="type in assigned_entity_dropdown_list" :value="type.id" :key="type.id">
              {{ type.name }}
            </option>
          </select>

          <button class="btn btn-primary-dark share-button ms-auto mt-3 d-flex align-items-center text-xxs" @click="share_trust_setup">
            Share Entity Setup
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
</teleport>
